import { axiosInstance } from '../api';


export default function (userId) {
    return axiosInstance.delete(`/api/users/${userId}`);
}